import React from "react";
import { Box, Typography } from "@mui/material";

const NotFound = () => (
  <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="80vh">
    <Typography variant="h2" color="error" gutterBottom>
      404
    </Typography>
    <Typography variant="h5">Page non trouvée</Typography>
  </Box>
);

export default NotFound;
